






















































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import {
  DrivewealthAccountManagementType,
  DrivewealthAccountSummary
} from "@/shared/types";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

@Component
export default class InvestmentBalancePanel extends Vue {
  formatCurrency = formatCurrency;

  drivewealthStore = useDrivewealthStore();
  hsaBalanceStore = useHsaDailyBalanceStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  @Prop()
  accountId: number;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  loadBalanceData (): void {
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2({
        username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId
      });
    }

    this.drivewealthStore.loadHsaBalanceAndThreshold({
      username: this.username, partnerId: this.partnerId, accountId: this.accountId
    });
  }

  @Watch("$props", { deep: true })
  reload () {
    this.loadBalanceData();
  }

  mounted (): void {
    this.loadBalanceData();
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  get cashAccountBalance (): number {
    return this.hsaBalanceStore.instantBalance.amount || this.hsaBalanceStore.balanceOnFileAmount;
  }

  get investmentBalance (): number {
    return this.accountSummaryV2.displayBalance;
  }

  get liquidBalance (): number {
    return this.accountSummaryV2.cashBalance;
  }

  get isLoaded (): boolean {
    const accountSummaryV2Loaded = this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
    const balanceThresholdLoaded = this.drivewealthStore.isHsaBalanceAndThresholdLoaded(this.accountId);

    return accountSummaryV2Loaded &&
        balanceThresholdLoaded;
  }

  get isLoading (): boolean {
    return !this.isLoaded;
  }

  get balanceTitleCopy (): string {
    if (this.isLoaded) {
      return this.isManagedAccount ? "Fair Market Value" : "Investment Balance";
    }
    return "Loading...";
  }

  get liquidTitleCopy (): string {
    if (this.isLoaded) {
      return "Liquid Balance (Not Invested)";
    }
    return "Loading...";
  }

  get availableTitleCopy (): string {
    if (this.isLoaded) {
      return "Available to Invest";
    }
    return "Loading...";
  }

  get availableToInvest () {
    return this.drivewealthStore.isHsaBalanceAndThresholdLoaded(this.accountId)
        ? this.drivewealthStore.hsaBalanceBeyondThreshold(this.accountId) : 0;
  }

  get isManagedAccount (): boolean {
    return this.accountSummaryV2 &&
        this.accountSummaryV2.accountManagementType === DrivewealthAccountManagementType.RiaManaged;
  }
}
